import classNames from "classnames";
import {Link} from "react-router-dom";

import styles from "./NavigationTab.module.css";

type Props = {
  className?: string;
  label: string;
  icon: string | JSX.Element;
  to: string;
  onClick?: () => void;
  selected: boolean;
  disabled?: boolean;
};

export default function NavigationTab({
  label,
  icon,
  selected,
  disabled,
  className,
  ...props
}: Props) {
  return (
    <Link
      className={classNames(
        styles.container,
        !selected && disabled && styles.disabled,
        className,
      )}
      {...props}
    >
      {typeof icon === "string" ? (
        <img className={styles.icon} src={icon} alt="" />
      ) : (
        icon
      )}
      <span className={classNames(styles.label, selected && styles.isSelected)}>
        {label}
      </span>
    </Link>
  );
}
